import { simpleListValue, simpleListExplanation, type SimpleListItem } from './simple-list';

/**
 * Auswahlfelder, in denen neben dem Kuerzel auch dessen Klartext stehen soll.
 *
 * Nutzer-Wunsch (11.09.2026, Mesoklima): "nicht nur den schluessel, sondern
 * auch die erklaerung mit ranschreiben". Wer selten damit arbeitet, kann aus
 * "fr" nicht ablesen, was gemeint ist - der Klartext ist gepflegt (in der
 * Listenverwaltung), er stand nur nirgends im Formular.
 *
 * **Gespeichert wird weiter das Kuerzel.** Es geht als Anhaengsel in die
 * Bodenform ein ("...-fr"); der Klartext ist reine Anzeige. Das Auswahlfeld
 * der Bibliothek trennt beides ueber `tableColumn` (Wert) und `displayColumn`
 * (Anzeige) - deshalb liefert der Datendienst fuer diese Listen Objekte statt
 * blosser Zeichenketten.
 *
 * Eine weitere Liste aufzunehmen heisst: ihren Namen hier eintragen UND in
 * `option.service.ts` `tableColumn: 'wert'` / `displayColumn: 'anzeige'`
 * setzen. Ohne den zweiten Schritt zeigt das Feld "[object Object]".
 */
export const LISTEN_MIT_ERKLAERUNG = new Set<string>(['Mesoklima']);

/** Ein Listeneintrag, wie ihn ein Auswahlfeld mit Klartext braucht. */
export interface EintragMitAnzeige {
	/** Der Wert, der gespeichert wird (das Kuerzel). */
	wert: string;
	/** Was im Auswahlfeld steht: "fr (frischer)" - ohne Klartext nur das Kuerzel. */
	anzeige: string;
}

/** Baut den Anzeigetext: Kuerzel voran, Klartext in Klammern dahinter. */
export function anzeigeMitErklaerung(wert: string, erklaerung: string): string {
	const w = (wert ?? '').trim();
	const e = (erklaerung ?? '').trim();
	if (!w) return ''; // die Leer-Option bleibt leer
	return e ? `${w} (${e})` : w;
}

/**
 * Rechnet eine rohe simple-Liste (Zeichenketten und/oder `{ wert, erklaerung }`)
 * in Eintraege um, die Wert und Anzeige getrennt fuehren.
 */
export function eintraegeMitAnzeige(roh: SimpleListItem[]): EintragMitAnzeige[] {
	return (roh ?? []).map(e => {
		const wert = simpleListValue(e);
		return { wert, anzeige: anzeigeMitErklaerung(wert, simpleListExplanation(e)) };
	});
}
